
import { useEffect, useState } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white/95 backdrop-blur-md shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-16">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="/" className="flex items-center gap-3 cursor-pointer group">
            <img
              src="https://static.readdy.ai/image/3b1a2dd7b171b6e7ce06ff7b01b788f6/1cebd8518503bbfa22b098278f31dba1.jpeg"
              alt="TRICORE 三鑑所"
              className="h-12 w-12 rounded-full object-cover"
            />
            <div className="flex flex-col">
              <span className={`font-body text-[11px] tracking-[0.15em] uppercase transition-colors ${
                scrolled ? 'text-neutral-500' : 'text-white/60'
              }`}>
                TRICORE
              </span>
              <span className={`font-heading text-[16px] font-bold tracking-wider transition-colors ${
                scrolled ? 'text-black' : 'text-white'
              }`}>
                三鑑所
              </span>
            </div>
          </a>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center gap-10">
            <a
              href="#services"
              className={`font-body text-[13px] tracking-wider transition-colors duration-300 cursor-pointer ${
                scrolled ? 'text-neutral-700 hover:text-black' : 'text-white/80 hover:text-white'
              }`}
            >
              核心服務
            </a>
            <a
              href="#about"
              className={`font-body text-[13px] tracking-wider transition-colors duration-300 cursor-pointer ${
                scrolled ? 'text-neutral-700 hover:text-black' : 'text-white/80 hover:text-white'
              }`}
            >
              關於我們
            </a>
            <a
              href="#process"
              className={`font-body text-[13px] tracking-wider transition-colors duration-300 cursor-pointer ${
                scrolled ? 'text-neutral-700 hover:text-black' : 'text-white/80 hover:text-white'
              }`}
            >
              鑑定流程
            </a>
            <a
              href="#contact"
              className={`font-body text-[13px] tracking-wider transition-colors duration-300 cursor-pointer ${
                scrolled ? 'text-neutral-700 hover:text-black' : 'text-white/80 hover:text-white'
              }`}
            >
              聯絡我們
            </a>
            <a
              href="#appointment"
              className={`px-6 py-3 font-body text-[13px] font-semibold tracking-wider transition-all duration-300 cursor-pointer whitespace-nowrap ${
                scrolled
                  ? 'bg-black text-white hover:bg-neutral-800'
                  : 'bg-white text-black hover:bg-white/90'
              }`}
            >
              預約鑑定
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
              scrolled ? 'text-black' : 'text-white'
            }`}
          >
            <i className={`text-2xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-neutral-200">
          <div className="px-6 py-6 space-y-4">
            <a
              href="#services"
              onClick={() => setMobileMenuOpen(false)}
              className="block font-body text-[14px] text-neutral-700 hover:text-black transition-colors cursor-pointer"
            >
              核心服務
            </a>
            <a
              href="#about"
              onClick={() => setMobileMenuOpen(false)}
              className="block font-body text-[14px] text-neutral-700 hover:text-black transition-colors cursor-pointer"
            >
              關於我們
            </a>
            <a
              href="#process"
              onClick={() => setMobileMenuOpen(false)}
              className="block font-body text-[14px] text-neutral-700 hover:text-black transition-colors cursor-pointer"
            >
              鑑定流程
            </a>
            <a
              href="#contact"
              onClick={() => setMobileMenuOpen(false)}
              className="block font-body text-[14px] text-neutral-700 hover:text-black transition-colors cursor-pointer"
            >
              聯絡我們
            </a>
            <a
              href="#appointment"
              onClick={() => setMobileMenuOpen(false)}
              className="block w-full px-6 py-3 bg-black text-white text-center font-body text-[14px] font-semibold tracking-wider hover:bg-neutral-800 transition-colors cursor-pointer whitespace-nowrap"
            >
              預約鑑定
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
